function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "26",
  height: "22",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.696 1.714L25.463 18.94A2 2 0 0123.767 22H2.233a2 2 0 01-1.696-3.06L11.304 1.714a2 2 0 013.392 0z",
  fill: "#FFD391"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14 13.295a1 1 0 01-2 0V7a1 1 0 012 0v6.295zm0 3.71a1 1 0 11-2 0V17a1 1 0 012 0v.006z",
  fill: "#FFF"
}))));